export function checkFeatureEnabled(state, featureName) {
  const {
    ui: { features },
  } = state;
  // eslint-disable-next-line no-prototype-builtins
  if (!features.hasOwnProperty(featureName)) return true;
  return features[featureName];
}
